import React from 'react';
import Tabs from '@material-ui/core/Tabs';

export function PasslyTabs(props: any) {
    const {withLongLine, ...rest} = props;
    return <div className={`tabs ${withLongLine ? 'tabs__long' : ''}`}>
        <Tabs {...rest} />
        {withLongLine ? (<div className='tabs__line' />) : null}
    </div>;
}


